export default __webpack_public_path__ + "static/media/successIcon.cdc13b1d.svg";